import { EntityRepository, Repository } from "typeorm";
import { CodeListMain } from "../code-list-main.entity";

@EntityRepository(CodeListMain)
export class CodeListMainRepository extends Repository<CodeListMain> {

}